import { useQuery } from '@tanstack/react-query';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { vcollectSubmissionsApi, SUBMISSION_STATUS_LABELS } from '../../api/vcollect-submission';
import { PageHeader } from '../../components/PageHeader';
import { SectionHeader } from '../../components/SectionHeader';
import { DataTable } from '../../components/DataTable';
import { StatusBadge } from '../../components/StatusBadge';
import { formatDate } from '../../utils/formatDate';

export function SubmissionsListPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const vcollectProjectId = searchParams.get('vcollectProjectId');
  const reviewStatus = searchParams.get('reviewStatus');
  const { data, isLoading, isError } = useQuery({
    queryKey: ['vcollect-submissions', vcollectProjectId, reviewStatus],
    queryFn: () => vcollectSubmissionsApi.list({ vcollectProjectId: vcollectProjectId ? Number(vcollectProjectId) : undefined, reviewStatus: reviewStatus ?? undefined }),
  });
  const submissions = data?.data ?? [];
  const filterNote = reviewStatus ? ` — filtered to ${SUBMISSION_STATUS_LABELS[reviewStatus] ?? reviewStatus}` : '';

  return (
    <div className="page">
      <PageHeader title={`VCollect — Submissions${filterNote}`} description="Field data synchronized from ODK Central. Use Sync Submissions from a form's builder page to pull in new ones." />
      <SectionHeader title="Submissions" />

      {isError && <div className="error-state">Failed to load submissions. Please try refreshing the page.</div>}
      {isLoading ? <div className="loading-state"><span className="loading-spinner" />Loading…</div> : (
        <DataTable
          rows={submissions}
          rowKey={(s) => s.id}
          emptyMessage="No submissions synced yet."
          columns={[
            { header: 'Reference', render: (s) => <a onClick={() => navigate(`/vcollect/submissions/${s.id}`)} className="table-link">{s.submission_reference}</a> },
            { header: 'Enumerator', render: (s) => s.enumerator_name ?? 'Unknown' },
            { header: 'Submitted', render: (s) => s.submitted_at ? formatDate(s.submitted_at) : '-' },
            { header: 'Received', render: (s) => formatDate(s.received_at) },
            { header: 'Status', render: (s) => <StatusBadge status={s.review_status} label={SUBMISSION_STATUS_LABELS[s.review_status]} /> },
          ]}
        />
      )}
    </div>
  );
}
